import {useRecordContext } from 'react-admin'
export const EventsResultsLink = () => {
	const record = useRecordContext()
	return <a target="_blank" rel="noopener noreferrer" href={record ? `/result/subevent/${record.SubEventId}` : ''}>{record ? `labs.competitor.com/result/subevent/${record.SubEventId}` : ''}</a>
}
export default EventsResultsLink